import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

export function Spinner({ className }: { className?: string }) {
  return (
    <Loader2
      className={cn('h-5 w-5 animate-spin text-fg-subtle', className)}
      aria-label="Loading"
      role="status"
    />
  );
}

export function PageSpinner() {
  return (
    <div className="flex h-full min-h-[300px] items-center justify-center">
      <Spinner className="h-7 w-7 text-primary-500/70" />
    </div>
  );
}

/* Skeleton primitives — use instead of spinners for content-shaped loading */

export function SkeletonBlock({ className }: { className?: string }) {
  return <div className={cn('skeleton', className)} />;
}

export function SkeletonKpiCard() {
  return (
    <div className="rounded-xl border border-border bg-surface p-4 shadow-card sm:p-5">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-2.5">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="h-8 w-28" />
          <SkeletonBlock className="h-2.5 w-16" />
        </div>
        <SkeletonBlock className="h-9 w-9 rounded-lg" />
      </div>
    </div>
  );
}

export function SkeletonRow({ cols = 5 }: { cols?: number }) {
  return (
    <tr className="border-b border-border/60">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3.5">
          <SkeletonBlock className={cn('h-3', i === 0 ? 'w-28' : i % 2 === 0 ? 'w-16' : 'w-20')} />
        </td>
      ))}
    </tr>
  );
}
